export default __webpack_public_path__ + "046a69f235479bf207ef6272a31eb493.png";